// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Enums
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';
// Translations
import { DOCUMENTS } from 'containers/upload-id/views/landing/translations/upload-id-landing.translations';
import { LayoutHookType } from '../types/layout.hook.type';

const getTitleValuesFromState = ({
  currentState,
  values,
}: Pick<LayoutHookType, 'currentState' | 'values'>): LayoutHookType['values'] =>
  currentState === AppStatesEnumeration.CHECKOUT_PENDING
    ? { documentType: <FormattedMessage id={DOCUMENTS[values?.documentType]} /> }
    : values;

export { getTitleValuesFromState };
